module.exports = __webpack_public_path__ + "d9447899cc5e0d0f779f25a2f4214f6f.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-taulia.png
// module id = 640
// module chunks = 0